import React, { useEffect } from "react";
import { PageLayout } from "../components/page-layout";
import { GymeaEduDashboard } from "../components/gymea-edu-dashboard";
import { WelcomeModal } from "../components/common/WelcomeModal";
import { useWelcomeModal } from "../hooks/useWelcomeModal";
import { ReportSeasonModal } from "../components/common/ReportSeasonModal";
import { useReportSeasonModal } from "../hooks/useReportSeasonModal";

export const DashboardPage: React.FC = () => {
  const { isWelcomeModalOpen, closeWelcomeModal } = useWelcomeModal();
  const { isReportSeasonOpen, closeReportSeasonModal } = useReportSeasonModal(isWelcomeModalOpen);

  useEffect(() => {
    document.body.classList.add('dashboard-page');
    
    return () => {
      document.body.classList.remove('dashboard-page');
    };
  }, []);

  return (
    <PageLayout className="dashboard-layout">
      <>
        <GymeaEduDashboard />
        <WelcomeModal 
          isOpen={isWelcomeModalOpen} 
          onClose={closeWelcomeModal}
        />
        <ReportSeasonModal
          isOpen={isReportSeasonOpen}
          onClose={closeReportSeasonModal}
        />
      </>
    </PageLayout>
  );
};